import * as React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {profileLinks} from '~/modules/Profile';
import {RenewView} from '~/modules/Profile/views/RecoveryView/RenewView';
import {RequestView} from '~/modules/Profile/views/RecoveryView/RequestView/intex';

export const RecoveryView = () => {
    const location = useLocation();
    const path = location.pathname;

    if (path === profileLinks.recoveryNew()) {
        return <RenewView/>;
    }

    if (path === profileLinks.recoveryRequest()) {
        return <RequestView/>;
    }

    return <Navigate to={profileLinks.recoveryRequest()} replace />;
};
